import React from 'react';
import { Container } from '../components/Container';
import { Shield, Factory, Users, TrendingDown } from 'lucide-react';
import { Link } from 'react-router-dom';
export function About() {
  return <div className="w-full bg-white" data-id="element-294">
      {/* Hero */}
      <div className="bg-[#111827] text-white py-20 relative overflow-hidden" data-id="element-295">
        <div className="absolute inset-0 z-0" data-id="element-296">
          <img src="https://images.unsplash.com/photo-1574629810360-7efbb1925536?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Team Huddle" className="w-full h-full object-cover opacity-30" data-id="element-297" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#111827] via-[#111827]/90 to-transparent" data-id="element-298"></div>
        </div>

        <Container className="relative z-10" data-id="element-299">
          <div className="max-w-3xl" data-id="element-300">
            <h1 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-4" data-id="element-301">
              About Primetime Sports
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-302"></div>
            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-303">
              We believe that ordering custom team uniforms shouldn't be
              stressful, expensive, or complicated. We built PTS to give teams
              factory-direct access to premium gear.
            </p>
          </div>
        </Container>
      </div>

      {/* Main Narrative */}
      <section className="py-20" data-id="element-304">
        <Container data-id="element-305">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-306">
            <div className="lg:w-1/2" data-id="element-307">
              <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase text-gray-900 mb-6" data-id="element-308">
                Factory-Direct Control. <br data-id="element-309" />
                <span className="text-pts-red" data-id="element-310">Unbeatable Value.</span>
              </h2>
              <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-311">
                <p data-id="element-312">
                  Primetime Sports Apparel (PTS) was founded on a simple
                  premise: cut out the middlemen. By operating factory-direct,
                  we maintain full control over the production process from the
                  initial design to the final stitch.
                </p>
                <p data-id="element-313">
                  This control allows us to offer high-quality, fully sublimated
                  custom gear at prices that traditional retail brands simply
                  cannot match. We don't just say we have competitive pricing—we
                  guarantee to beat any comparable quote you bring us.
                </p>
                <p data-id="element-314">
                  But great pricing means nothing without reliability. That's
                  why we've built an ordering process focused on accuracy,
                  featuring dedicated art support, mini photo approvals, and
                  full-size sample checks before your team's order ever hits the
                  production floor.
                </p>
              </div>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-315">
              <div className="relative" data-id="element-316">
                <div className="absolute -inset-3 bg-pts-red/10 rounded-2xl transform rotate-2" data-id="element-317"></div>
                <img src="https://cdn.magicpatterns.com/uploads/shtxuYWATmr87BaFU8L23Q/About_Us.png" alt="Custom team celebrating in PTS uniforms on the field" className="relative rounded-xl shadow-xl w-full h-auto object-cover border border-gray-200" data-id="element-318" />
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-319">
        <Container data-id="element-320">
          <div className="text-center mb-16" data-id="element-321">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-322">
              What Drives Us
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto" data-id="element-323"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-324">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-325">
              <Factory className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-326" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-327">
                Factory Direct
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-328">
                No middlemen. We control the facility, the timeline, and the
                quality of every garment we produce.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-329">
              <TrendingDown className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-330" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-331">
                Quote Beating
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-332">
                We are committed to making team sports affordable. Bring us a
                quote and we will beat it.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-333">
              <Shield className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-334" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-335">
                Confidence
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-336">
                Through our rigorous approval process and sample programs, you
                know exactly what you're getting.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center" data-id="element-337">
              <Users className="h-12 w-12 text-pts-red mx-auto mb-6" data-id="element-338" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-339">
                Relationships
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-340">
                We don't just want your first order; we want to outfit your
                program for years to come.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="py-20 bg-pts-red text-white text-center" data-id="element-341">
        <Container data-id="element-342">
          <h2 className="font-oswald text-4xl font-bold uppercase mb-6" data-id="element-343">
            Experience the PTS Difference
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto mb-10" data-id="element-344">
            Join the thousands of teams, schools, and leagues that trust
            Primetime Sports Apparel for their custom gear.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-345">
            <Link to="/get-started" className="bg-white text-pts-red hover:bg-gray-100 px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors shadow-lg" data-id="element-346">
              Start Your Order
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white hover:bg-white hover:text-pts-red text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-347">
              Contact Our Team
            </Link>
          </div>
        </Container>
      </section>
    </div>;
}